export function downloadTargetedEmailCsv(emails: Array<string>, filename: string): void {
    let csv = ['Email'].concat((emails || []).map((email: string) => escapeCsvCell(email))).join('\r\n');
    let url = URL.createObjectURL(new Blob([csv], {type: 'text/csv;charset=utf-8'}));
    let link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 0);
}

function escapeCsvCell(value: string): string {
    let stringValue = value === null || value === undefined ? '' : String(value);
    return /[",\n\r]/.test(stringValue)
        ? '"' + stringValue.replace(/"/g, '""') + '"'
        : stringValue;
}



// WEBPACK FOOTER //
// ./js/utils/TargetedEmailCsvExporter.ts